var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 53,
    viewBox: "0 0 184 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.423 52.9998H6.7855C3.05517 52.9998 0 50.0169 0 46.3748V6.62497C0 2.98289 3.05517 1.95501e-06 6.7855 1.95501e-06H176.423C180.153 1.95501e-06 183.209 2.98289 183.209 6.62497V46.3748C183.209 50.0169 180.153 52.9998 176.423 52.9998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.423 1.06165C179.565 1.06165 182.121 3.55761 182.121 6.62497V46.3748C182.121 49.4421 179.565 51.9381 176.423 51.9381H6.7855C3.64382 51.9381 1.08738 49.4421 1.08738 46.3748V6.62497C1.08738 3.55761 3.64382 1.06165 6.7855 1.06165H176.423ZM176.423 1.95501e-06H6.7855C3.05517 1.95501e-06 0 2.98289 0 6.62497V46.3748C0 50.0169 3.05517 52.9998 6.7855 52.9998H176.423C180.153 52.9998 183.209 50.0169 183.209 46.3748V6.62497C183.209 2.98289 180.153 1.95501e-06 176.423 1.95501e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3503 13.5731C64.3503 14.6795 64.011 15.5656 63.3427 16.2264C62.5742 17.0098 61.5734 17.404 60.3469 17.404C59.1747 17.404 58.1738 17.0032 57.3528 16.2132C56.53 15.4116 56.1195 14.4278 56.1195 13.2502C56.1195 12.0726 56.53 11.0888 57.3528 10.2938C58.1738 9.49713 59.1747 9.09631 60.3469 9.09631C60.9304 9.09631 61.4868 9.21391 62.0178 9.43253C62.5471 9.65281 62.978 9.95093 63.2901 10.3186L62.581 11.0176C62.0365 10.3898 61.2952 10.0801 60.3469 10.0801C59.4919 10.0801 58.7506 10.3716 58.1212 10.9596C57.4987 11.5492 57.1865 12.3127 57.1865 13.2502C57.1865 14.1876 57.4987 14.9578 58.1212 15.5474C58.7506 16.1287 59.4919 16.4268 60.3469 16.4268C61.2544 16.4268 62.0178 16.1287 62.62 15.5408C63.017 15.1515 63.2426 14.6149 63.302 13.9292H60.3469V12.9719H64.2893C64.3368 13.179 64.3503 13.3794 64.3503 13.5731Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6048 10.2538H66.9016V12.7713H70.24V13.7286H66.9016V16.2461H70.6048V17.2217H65.8532V9.27832H70.6048V10.2538Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0188 17.2217H73.9705V10.2538H71.699V9.27832H77.2919V10.2538H75.0188V17.2217Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3395 17.2217V9.27832H82.3861V17.2217H81.3395Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0257 17.2217H85.9859V10.2538H83.7059V9.27832H89.3057V10.2538H87.0257V17.2217Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8946 16.1999C99.0922 17.0032 98.0981 17.404 96.9123 17.404C95.7198 17.404 94.7257 17.0032 93.9233 16.1999C93.1226 15.3983 92.724 14.4145 92.724 13.2502C92.724 12.0858 93.1226 11.102 93.9233 10.3004C94.7257 9.49712 95.7198 9.09631 96.9123 9.09631C98.0913 9.09631 99.0854 9.49712 99.8878 10.307C100.695 11.1153 101.094 12.0925 101.094 13.2502C101.094 14.4145 100.695 15.3983 99.8946 16.1999ZM94.6986 15.5341C95.3025 16.1287 96.037 16.4268 96.9123 16.4268C97.7809 16.4268 98.5222 16.1287 99.1193 15.5341C99.7215 14.9395 100.027 14.176 100.027 13.2502C100.027 12.3243 99.7215 11.5608 99.1193 10.9662C98.5222 10.3716 97.7809 10.0735 96.9123 10.0735C96.037 10.0735 95.3025 10.3716 94.6986 10.9662C94.0963 11.5608 93.791 12.3243 93.791 13.2502C93.791 14.176 94.0963 14.9395 94.6986 15.5341Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.565 17.2217V9.27832H103.837L107.793 15.4561H107.839L107.793 13.929V9.27832H108.839V17.2217H107.747L103.604 10.7391H103.559L103.604 12.2728V17.2217H102.565Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4661 28.8218C89.2786 28.8218 86.6747 31.1902 86.6747 34.458C86.6747 37.6993 89.2786 40.0925 92.4661 40.0925C95.6604 40.0925 98.2643 37.6993 98.2643 34.458C98.2643 31.1902 95.6604 28.8218 92.4661 28.8218ZM92.4661 37.8732C90.7171 37.8732 89.2124 36.4637 89.2124 34.458C89.2124 32.4258 90.7171 31.0412 92.4661 31.0412C94.2151 31.0412 95.7265 32.4258 95.7265 34.458C95.7265 36.4637 94.2151 37.8732 92.4661 37.8732ZM79.8298 28.8218C76.6355 28.8218 74.0384 31.1902 74.0384 34.458C74.0384 37.6993 76.6355 40.0925 79.8298 40.0925C83.0224 40.0925 85.6212 37.6993 85.6212 34.458C85.6212 31.1902 83.0224 28.8218 79.8298 28.8218ZM79.8298 37.8732C78.0791 37.8732 76.5694 36.4637 76.5694 34.458C76.5694 32.4258 78.0791 31.0412 79.8298 31.0412C81.5788 31.0412 83.0834 32.4258 83.0834 34.458C83.0834 36.4637 81.5788 37.8732 79.8298 37.8732ZM64.7931 30.5493V32.9442H70.6507C70.4794 34.2824 70.0214 35.2662 69.3191 35.9519C68.4641 36.78 67.1324 37.6993 64.7931 37.6993C61.1883 37.6993 58.3656 34.8588 58.3656 31.3393C58.3656 27.8198 61.1883 24.9793 64.7931 24.9793C66.7423 24.9793 68.1604 25.723 69.2071 26.6869L70.9357 24.9992C69.4717 23.6344 67.5243 22.586 64.7931 22.586C59.8499 22.586 55.6955 26.513 55.6955 31.3393C55.6955 36.1656 59.8499 40.0925 64.7931 40.0925C67.4649 40.0925 69.4717 39.2379 71.0494 37.6347C72.666 36.0563 73.1698 33.8369 73.1698 32.0448C73.1698 31.4883 73.1223 30.9766 73.0375 30.5493H64.7931ZM126.28 32.4059C125.803 31.1455 124.333 28.8218 121.337 28.8218C118.368 28.8218 115.896 31.1058 115.896 34.458C115.896 37.6148 118.343 40.0925 121.622 40.0925C124.273 40.0925 125.803 38.5141 126.433 37.5949L124.465 36.3146C123.808 37.2521 122.914 37.8732 121.622 37.8732C120.338 37.8732 119.416 37.2984 118.826 36.1656L126.546 33.0469L126.28 32.4059ZM118.409 34.2824C118.343 32.1094 120.137 30.9964 121.423 30.9964C122.431 30.9964 123.286 31.4883 123.571 32.1922L118.409 34.2824ZM112.134 39.7497H114.672V23.1873H112.134V39.7497ZM107.978 30.0772H107.893C107.323 29.418 106.236 28.8218 104.858 28.8218C101.968 28.8218 99.3245 31.2995 99.3245 34.4762C99.3245 37.6347 101.968 40.0925 104.858 40.0925C106.236 40.0925 107.323 39.4913 107.893 38.8122H107.978V39.6205C107.978 41.7753 106.799 42.933 104.897 42.933C103.347 42.933 102.385 41.8399 101.988 40.9206L99.7809 41.82C100.417 43.3139 102.102 45.1523 104.897 45.1523C107.873 45.1523 110.383 43.4431 110.383 39.2843V29.1646H107.978V30.0772ZM105.075 37.8732C103.326 37.8732 101.862 36.4438 101.862 34.4762C101.862 32.4904 103.326 31.0412 105.075 31.0412C106.799 31.0412 108.158 32.4904 108.158 34.4762C108.158 36.4438 106.799 37.8732 105.075 37.8732ZM138.161 23.1873H132.092V39.7497H134.623V33.4742H138.161C140.972 33.4742 143.729 31.4883 143.729 28.3299C143.729 25.1731 140.965 23.1873 138.161 23.1873ZM138.228 31.1703H134.623V25.4911H138.228C140.117 25.4911 141.196 27.0231 141.196 28.3299C141.196 29.6118 140.117 31.1703 138.228 31.1703ZM153.873 28.7903C152.044 28.7903 150.143 29.5787 149.361 31.326L151.607 32.2452C152.09 31.326 152.979 31.0279 153.919 31.0279C155.232 31.0279 156.564 31.7981 156.584 33.1578V33.3317C156.126 33.0734 155.145 32.6908 153.939 32.6908C151.52 32.6908 149.055 33.9909 149.055 36.4173C149.055 38.6367 151.037 40.066 153.264 40.066C154.967 40.066 155.907 39.3157 156.497 38.4429H156.584V39.7232H159.028V33.3698C159.028 30.4333 156.782 28.7903 153.873 28.7903ZM153.568 37.8665C152.74 37.8665 151.586 37.4657 151.586 36.4637C151.586 35.1818 153.025 34.6899 154.27 34.6899C155.385 34.6899 155.907 34.93 156.584 35.2464C156.386 36.78 155.034 37.8665 153.568 37.8665ZM167.934 29.153L165.025 36.3329H164.939L161.931 29.153H159.202L163.721 39.1866L161.142 44.7698H163.787L170.75 29.153H167.934ZM145.12 39.7497H147.658V23.1873H145.12V39.7497Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1613 9.98869C13.7627 10.3961 13.532 11.0305 13.532 11.852V41.1542C13.532 41.9757 13.7627 42.6101 14.1613 43.0175L14.2597 43.1069L31.0776 26.6936V26.306L14.2597 9.89263L14.1613 9.98869Z",
    fill: "url(#paint0_linear_43_393)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6773 32.1676L31.0775 26.6937V26.3062L36.6841 20.8323L36.8096 20.9035L43.4492 24.5919C45.3441 25.6387 45.3441 27.3612 43.4492 28.4146L36.8096 32.0964L36.6773 32.1676Z",
    fill: "url(#paint1_linear_43_393)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8096 32.0962L31.0775 26.4998L14.1613 43.0175C14.7906 43.6634 15.8169 43.7413 16.9841 43.0953L36.8096 32.0962Z",
    fill: "url(#paint2_linear_43_393)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8096 20.9037L16.9841 9.90457C15.8169 9.26526 14.7906 9.3431 14.1613 9.98904L31.0775 26.5001L36.8096 20.9037Z",
    fill: "url(#paint3_linear_43_393)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_393",
    x1: 29.5843,
    y1: 41.4594,
    x2: 7.35413,
    y2: 18.6905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43_393",
    x1: 45.9166,
    y1: 26.4981,
    x2: 13.079,
    y2: 26.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_43_393",
    x1: 33.6927,
    y1: 23.4574,
    x2: 3.5467,
    y2: -7.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_43_393",
    x1: 9.90311,
    y1: 52.7666,
    x2: 23.3646,
    y2: 38.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.06630c8d690116f87ce4af87f0c55c2e.svg";
export { ForwardRef as ReactComponent };